module.exports = __webpack_public_path__ + "img/tv.33484163.svg";